/**
 * Extract a human-readable error message from an API error.
 *
 * Handles the different shapes thrown by api.js:
 * - 403: plain object { status, message }
 * - Other: axios error with response.data (string or object)
 *
 * @param {*} error - The caught error object
 * @param {string} fallback - Fallback message when nothing can be extracted
 * @returns {string}
 */
export function getBackendErrorMessage(error, fallback = "") {
  const data = error?.response?.data;
  return (
    data?.error ||
    data?.message ||
    (typeof data === "string" ? data : null) ||
    error?.message ||
    fallback
  );
}
